import "./scss/reservationList.scss";
import { useDispatch, useSelector } from "react-redux";
import { rootReducer } from "../store/store";
import Header from "../components/Header";
import { ReservationResponse } from "../types/ReservationTypes";
import { resOneInfo } from "../actions/authActions";
import { useHistory } from "react-router-dom";
import AlertModal from "../components/AlertModal";
import { useState } from "react";
import axiosInstance from "../api/axiosInstance";
import ReservationService from "../api/ReservationService";
type AuthState = ReturnType<typeof rootReducer>;
const ReservationList: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [modalTitle, setModalTitle] = useState<string>("차량 미배정");
  const [modalContent, setModalContent] = useState<string>("");
  const [modalShow, setModalShow] = useState<boolean>(false);
  const resInfo = useSelector((state: AuthState) => state.store.resInfo);

  const data = resInfo && resInfo.data;

  function formatTime(timestamp: number): string {
    const date = new Date(timestamp);
    const hours = date.getHours();
    const minutes = date.getMinutes();

    // 시간과 분을 2자리 숫자로 포맷팅
    const formattedHours = hours.toString().padStart(2, "0");
    const formattedMinutes = minutes.toString().padStart(2, "0");

    // 시간과 분을 문자열로 조합
    const formattedTime = `${formattedHours}:${formattedMinutes}`;

    return formattedTime;
  }

  function formatTimestamp(timestamp: number): string {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  const resSelect = (item: ReservationResponse) => {
    if (item.reservationStatus === "00000") {
      setModalTitle("데스크로 문의해주세요.");
      setModalContent("예약 상태 확인이 필요합니다.");
      setModalShow(true);
      return false;
    }

    if (item.dispatchCarId === 0 || !item.dispatchCarId) {
      setModalContent("차량이 배정 되지 못했습니다.데스크에 문의 바랍니다.");
      setModalShow(true);
      return false;
    }

    if (!item.exportLocationDetail) {
      setModalTitle("차량 준비중");
      setModalContent("차량이 준비중입니다. 잠시만 기다려주세요.");
      setModalShow(true);
      return false;
    }

    const nowDateTime = new Date();

    const takeoverDateTime = new Date(item.takeoverDtm as unknown as Date);

    const timeDifferenceMs = takeoverDateTime.getTime() - nowDateTime.getTime();

    const timeDifferenceMin = Math.floor(timeDifferenceMs / (1000 * 60));

    if (timeDifferenceMin > 20) {
      setModalTitle("차량 대여 이전");
      setModalContent("차량 대여는 20분 전에는 불가합니다.");
      setModalShow(true);
      return false;
    }
    
    // 현재 예약이 조회중 (키오스크 사용 중) 이면 해당 함수에서 alert 처리
    ReservationService.processLock(
      item.companyId, item.reservationId, item.processLockVersion
    ).then((response) => {
      if(response.data.status === 200) {
        console.log(response);

        item.processLockVersion = response.data.data.processLockVersion;

        dispatch(resOneInfo(item));
        history.push("/reservation");
      } else {
        console.log(response);
        setModalTitle("현재 사용 중");
        setModalContent("해당 예약건이 타 키오스크에서 사용중입니다.");
        setModalShow(true);
        return false;
      }
    });
  };

  return (
    <>
      <Header></Header>
      {modalShow && (
        <AlertModal
          onClose={() => {
            setModalShow(false);
          }}
          title={modalTitle}
          content={modalContent}
        ></AlertModal>
      )}
      <div className="res-list-wrap">
        <div className="res-list-title-wrap">
          <span>예약목록</span>
        </div>

        <div className="list-wrap">
          <div className="list-header">
            <div style={{ width: "20%" }}>출고시간</div>
            <div style={{ width: "20%" }}>렌트카업체</div>
            <div style={{ width: "45%" }}>예약정보</div>
            <div style={{ width: "12%" }}>상태</div>
          </div>
          {data &&
            data.list.map((item: ReservationResponse, index: number) => (
              <div className="list-content" key={index}>
                <div style={{ width: "20%" }} className="take-time">
                  {formatTime(item.takeoverDtm || 0)}
                  {item.preRegStatus === "Y" && <span>사전등록자</span>}
                </div>
                <div style={{ width: "20%" }} className="company-name">
                  {item.companyName}
                </div>
                <div style={{ width: "45%" }} className="res-info">
                  <div className="res-date">
                    {formatTimestamp(item.reservationDtm || 0)}
                  </div>
                  <div className="res-req">
                    {item.req1stUserName} ({item.req1stUserTel})
                  </div>
                  <div className="res-car">{item.modelName}</div>
                </div>
                <div style={{ width: "15%" }} className="car-btn-wrap">
                  <button
                    onClick={() => {
                      if(item.processType !== "LOCK") {
                        resSelect(item);
                      }
                    }}
                    className={
                      (item.dispatchCarId === 0 || item.processType === "LOCK") ? "not-car-start" : "car-start"
                    }
                  >
                    {
                      item.dispatchCarId === 0 ? "미배정" : (
                        item.processType === "LOCK" ? "체크인 중" : "배정"
                      )
                    }
                  </button>
                </div>
              </div>
            ))}

          <div className="list-dec-wrap">
            <span>
              무인배차 서비스를 이용할 예약내역을 선택해주세요. <br />
              미배정 상태인 경우 서비스 이용이 불가합니다. 직원에게
              문의바랍니다.
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReservationList;
